import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./SkillsProgramSetup.css";
import SearchView from "../../widgets/SearchView";
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import withMenuPermission from "../../widgets/withMenuPermission";
import ShortCourseSetupSearchForm from "./ShortCourseSetupSearchForm";


const utils = new ViewUtils();
const headCells = [
    { id: 'ShortCourseCode', numeric: false, disablePadding: true, label: 'Short Course Code' },
    { id: 'ShortCourseTitle', numeric: false, disablePadding: true, label: 'Short Course Title' }

];

class ShortCourseSetupSearch extends Component {

    constructor(props) {
        super(props)


        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "ShortCourseCode", Value: "" },
                { Name: "ShortCourseTitle", Value: "" }
            ]
            :
            [
                { Name: "ShortCourseCode", Value: "" },
                { Name: "ShortCourseTitle", Value: "" },
            ]

        let model = !utils.isNull(this.props.programmeId) ?
            {
                ShortCourseCode: "",
                ShortCourseTitle: "",
                id: this.props.programmeId
            }
            :
            {
                ShortCourseCode: "",
                ShortCourseTitle: ""
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }

        if (!utils.isNull(props.personId)) {
            model.PersonID = props.personId;
            this.searchParameters.push({ Name: "PersonID", Value: props.personId })
        }

        this.state = {
            model: model,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Short Course', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    clearSearch(e) {
        this.setState({
            model: {
                ShortCourseCode: "",
                ShortCourseTitle: "",
                id: this.props.programmeId
            }
        });
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/ShortCourseSetup/GetSearch"}
                    entityViewPath='/ShortCourseSetup'
                    title='Short Course'
                    model={this.state.model} toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="ShortCourseTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch} history={this.props.history}
                    multiSelect={this.props.multiSelect} selectionCallbackMode={this.props.selectionCallbackMode}
                    deleteUrl={"api/sims/ShortCourseSetup/RemoveShortCourse"} useDeletePost={true}
                    promptTitle={"Remove Short Course"}
                    promptContent={"Removing the short course is a permanent action and the skills programme will not be available going forward. Are you sure you want to remove this short course?"}
                    editPermission={this.props.menuPermissionItem.Edit}
                    allowClear={this.props.allowClear}
                    clearPress={(e) => { this.clearSearch(e) }}
                >
                    <ShortCourseSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>

            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(ShortCourseSetupSearch));
